import React, { Fragment, useState, useContext } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  RawButton as Button,
} from '@the-platform-group/component-library'

const initialState = {
  open: false,
  title: '',
  body: '',
  onConfirm: () => {},
  onCancel: null,
}

const ConfirmationDialogContext = React.createContext({
  createConfirmationDialog() {},
})

function ConfirmationDialogProvider({ children }) {
  const [state, setState] = useState(initialState)
  const createConfirmationDialog = ({ title, body, onConfirm, onCancel, confirmButtonText }) => {
    setState({ open: true, title, body, onConfirm, onCancel, confirmButtonText })
  }
  const handleDismiss = () => {
    const { onCancel } = state
    setState(initialState)
    onCancel?.()
  }
  const handleConfirm = () => {
    const { onConfirm } = state
    setState(initialState)
    onConfirm()
  }

  return (
    <ConfirmationDialogContext.Provider value={{ createConfirmationDialog }}>
      <ConfirmationDialogComponent
        open={state.open}
        title={state.title}
        body={state.body}
        confirmButtonText={state.confirmButtonText}
        onDismiss={handleDismiss}
        onConfirm={handleConfirm}
      />
      {children}
    </ConfirmationDialogContext.Provider>
  )
}

const useConfirmationDialog = () => {
  const { createConfirmationDialog } = useContext(ConfirmationDialogContext)
  return {
    createConfirmationDialog,
  }
}

const ConfirmationDialogComponent = ({
  open,
  title,
  body,
  onConfirm,
  confirmButtonText = 'Confirm',
  onDismiss,
}) => {
  return (
    <Fragment>
      <Dialog open={open} onClose={onDismiss}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{body}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onDismiss}>Cancel</Button>
          <Button onClick={onConfirm} variant="contained">
            {confirmButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}

export { ConfirmationDialogProvider, useConfirmationDialog }
